/* eslint class-methods-use-this: off */

import { Logging } from '@vcd-ecm-ui/Common';
import { LOCAL_STORAGE_AUTH_ITEM } from '@vcd-ecm-ui/LoginGatekeeper';
import { AuthUrls, LOCAL_STORAGE_AUTH_IDP_ITEM } from './AuthUrlFactory';
import { TOKEN_REFRESH_URL } from '../../constants/constants';

/**
 * Base class for common utilities for building Auth URLs and Functions.
 */
export default abstract class BaseAuthUrls implements AuthUrls {
  abstract getIdP(): string;
  abstract getLoginUrl(): string;
  abstract getLogoutUrl(): string;
  abstract getTokenRequestUrl(): string;

  protected getAuthIdToken(): string {
    const authCache = localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM));
    return authCache && authCache.idToken;
  }

  getTokenRefreshUrl(): string {
    return TOKEN_REFRESH_URL;
  }

  logoutFunction(): void {
    const logoutUrl = this.getLogoutUrl();

    Logging.Info('Logging out!');
    Logging.Info('Redirecting to: ', logoutUrl);

    localStorage.removeItem(LOCAL_STORAGE_AUTH_ITEM);
    localStorage.removeItem(LOCAL_STORAGE_AUTH_IDP_ITEM);
    window.location.href = logoutUrl;
  }

  idpHasChanged(): boolean {
    const lastIdP = localStorage.getItem(LOCAL_STORAGE_AUTH_IDP_ITEM);

    const idpHasChanged = lastIdP != null && (lastIdP !== this.getIdP());
    if (idpHasChanged) {
      Logging.Info('Current IdP does not match last used.  A logout should be forced.');
    }

    return idpHasChanged;
  }
}
